import "@babel/polyfill"
import Vue from 'vue'
import ArchiveApp from './ArchiveApp.vue'
import router from './router'
import VueImg from 'v-img'
import axios from 'axios'
import VueMoment from 'vue-moment'
import VueGtag from "vue-gtag"
import VueI18n from 'vue-i18n'
import en from './locales/en.json'
import ja from './locales/ja.json'
import VueYoutube from 'vue-youtube'
Vue.use(VueYoutube)
const messages = {
    en: en,
    ja: ja
}
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: lang,
    fallbackLocale: 'ja',
    formatFallbackMessages: true,
    messages
})
Vue.use(VueGtag, {
    config: { id: ga_id }
})

axios.defaults.baseURL = api_url
Vue.use(VueMoment)
Vue.use(VueImg)
new Vue({
    router,
    el: '#jomon-archives',
    i18n,
    render: h => h(ArchiveApp)
})
